export default __webpack_public_path__ + "static/media/Spinner-transparent.f8cfa40e.gif";